// Shared across App.js and Reports.js so both stay in sync with the same
// mushroom type / bag type / stage definitions.

export const mushroomTypes = {
  'Beech': { incubationDays: [45,60], color: 'bg-orange-300 border-orange-900' },
  'Black Oyster': { incubationDays: [21,28], color: 'bg-slate-500 border-slate-900' },
  'Chestnut': { incubationDays: [35,50], color: 'bg-amber-100 border-amber-300' },
  'Enoki': { incubationDays: [14,21], color: 'bg-yellow-200 border-yellow-900' },
  'Lion\'s Mane': { incubationDays: [10,14], color: 'bg-purple-300 border-purple-900' },
  'King Oyster': { incubationDays: [28,35], color: 'bg-violet-400 border-violet-900' },
  'Maitake': { incubationDays: [45,60], color: 'bg-amber-100 border-amber-300' },
  'Oyster': { incubationDays: [14,21], color: 'bg-sky-400 border-sky-900' },
  'Pink Oyster': { incubationDays: [14,21], color: 'bg-pink-300 border-pink-900' },
  'Pioppino': { incubationDays: [45,60], color: 'bg-emerald-300 border-emerald-900' },
  'Reishi': { incubationDays: [30,45], color: 'bg-red-100 border-red-300' },
  'Shiitake': { incubationDays: [60,90], color: 'bg-green-500 border-green-900' }
};

export const bagTypes = ['10lb Bag', '5lb Bag', 'Grow Kit'];

export const stage_names = ['Incubation', 'Fruiting', 'Harvested'];
